import { authService } from '/assets/js/api/AuthService.js';
document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname.includes('/logout')) {
        authService.logout();
    }
});
